﻿/*---[ ESLint ]---*/
/*
    global _msg_notsaved: true,
           breadcrumb, 
           precommsglog
*/

window.precommsglog = function () {

    function addGroupToSelected(groupId) {

        var lbSelected = $("#PreComMsg_CplSelected").data("kendoListBox");
        if (lbSelected == null || lbSelected == undefined) return;

        // check it is not already in selected list
        var found = false;
        var view = lbSelected.dataSource.view();

        for (var i = 0; i < view.length && !found; i++) {
            found = view[i].Type == '2' && view[i].GroupID == groupId;
        }
        if (found) return;

        // check it is in available (not selected) list
        var lbNotSelected = $("#PreComMsg_CplNotSelected").data("kendoListBox");
        if (lbNotSelected == null || lbNotSelected == undefined) return;

        var foundNS = false;
        var viewNS = lbNotSelected.dataSource.view();
        var iNS;

        for (iNS = 0; ((iNS < viewNS.length) && !foundNS); iNS++) {
            foundNS = viewNS[iNS].Type == '2' && viewNS[iNS].GroupID == groupId;
        }

        if (!foundNS) return;

        // set item as selected
        lbNotSelected.select(lbNotSelected.items()[iNS - 1]);

        // move it to the right-hand list (selected)
        precommsglog.LR_rightClicked();
    }

    function enabled(readOnly) {
        if (readOnly) {
            viewmode.disableAllInputs("DivOverview");
        }
    }

    function visibility() {

        $("#SendButton").removeAttr("disabled");

        var ddlMsgType = $("#MsgType").data("kendoDropDownList");

        if (ddlMsgType != null && ddlMsgType != undefined) {

            if (ddlMsgType.value() == '2') {
                main.setHideDivBootstrap("DivPreDefinedMsg", false);
                main.setHideDivBootstrap("DivScenarioMsg", true);
            } else {
                main.setHideDivBootstrap("DivPreDefinedMsg", true);
                main.setHideDivBootstrap("DivScenarioMsg", false);
                main.setHideDivBootstrap("DivExtraInfo", false);
            }

        } else {
            main.setHideDivBootstrap("DivPreDefinedMsg", false);
            main.setHideDivBootstrap("DivScenarioMsg", true);
        }

        loadLRGroupsAndUsers();
    }

    function loadLRGroupsAndUsers() {

        // get selected preComMsgScenarioMsgID
        var preComMsgScenarioMsgID = 0;

        var ddl = $("#PreComMsgScenarioMsgID").data("kendoDropDownList");
        if (ddl != null && ddl != undefined && ddl.dataItem(ddl.selected).Value != '') {
            preComMsgScenarioMsgID = ddl.dataItem(ddl.selected).Value;
        }

        $("#DivLeftRight").load(appsettings.getUrl("PreComMsgLog/GetGroupsAndUsers?preComMsgScenarioMsgID=" + preComMsgScenarioMsgID));
    }

    return {

        initialize: function (readOnly) {
            enabled(readOnly);
            visibility();
        },

        onMsgTypeChanged: function () {
            visibility();
        },

        onPredefinedMsgTypeChanged: function (e) {
            var textarea = $("#MessageTextArea").data("kendoTextArea");
            if (textarea != null && textarea != undefined) {
                textarea.value(this.value());
            }
        },        

        onPreComMsgScenarioChanged: function () {
            precommsglog.refresh_PreComMsgScenarioMsg();
        },

        refresh_PreComMsgScenarioMsg: function () {
            var ddlPreComMsgScenarioMsg = $("#PreComMsgScenarioMsgID").data("kendoDropDownList");

            if (ddlPreComMsgScenarioMsg != null && ddlPreComMsgScenarioMsg != undefined) {
                ddlPreComMsgScenarioMsg.dataSource.read();
            }
        },        
       
        dataSelectedPreComMsgScenarioID: function () {

            var ddlPreComMsgScenarioID = $("#PreComMsgScenarioID").data("kendoDropDownList");
            var preComMsgScenarioId = 0;

            if (ddlPreComMsgScenarioID != null && ddlPreComMsgScenarioID != undefined) {
                preComMsgScenarioId = ddlPreComMsgScenarioID.value();
            }

            return {
                preComMsgScenarioID: preComMsgScenarioId
            };
        },

        onPreComMsgScenarioMsgChanged: function (e) {

            // update LR users/groups
            loadLRGroupsAndUsers();

            // fill message
            precommsglog.updateTextAreaWithScenarioInfo(e);

            // show hide other options
            if (e.sender.select() == 0) {
                main.setHideDivBootstrap("DivExtraInfo", false);
            } else {
                main.setHideDivBootstrap("DivExtraInfo", true);
                precommsglog.loadExtraInfo();
            }
        },

        updateTextAreaWithScenarioInfo: function () {

            var precomMsgScenarioText = "";
            var pms = $("#PreComMsgScenarioID").data("kendoDropDownList");
            if (pms != null && pms != undefined && pms.select() > 0) {
                precomMsgScenarioText = pms.dataItem(pms.selected).Text;
            }

            var pmsm = $("#PreComMsgScenarioMsgID").data("kendoDropDownList");
            if (pmsm != null && pmsm != undefined && pmsm.select() > 0) {
                precomMsgScenarioText += ", " + pmsm.dataItem(pmsm.selected).MessageText;

                var cb_Priority = $("#Priority")[0];
                if (cb_Priority != null && cb_Priority != undefined) {
                    cb_Priority.checked = pmsm.dataItem(pmsm.selected).Priority;
                }

                var cb_Response = $("#Response")[0];
                if (cb_Response != null && cb_Response != undefined) {
                    cb_Response.checked = pmsm.dataItem(pmsm.selected).Response;
                }

                var calGrp = pmsm.dataItem(pmsm.selected).CalculateGroupID;
                var cb_CalculateGroup = $("#CalculateGroup")[0];
                if (cb_CalculateGroup != null && cb_CalculateGroup != undefined) {
                    cb_CalculateGroup.checked = (calGrp !== undefined && calGrp !== null) ? pmsm.dataItem(pmsm.selected).LCD : false;

                    main.setHideDivBootstrap("DivDDLCalculateGroup", cb_CalculateGroup.checked);

                    var ddlCalGrp = $("#DDL_CalculateGroup").data("kendoDropDownList");
                    if (cb_CalculateGroup.checked && ddlCalGrp != null && ddlCalGrp != undefined) {

                        // find calGrp
                        var found = false;
                        for (var i = 0; ((i < ddlCalGrp.dataSource.view().length) && !found); i++) {
                            found = ddlCalGrp.dataSource.view()[i].Value == calGrp;
                        }

                        if (found) {
                            ddlCalGrp.select(i);
                        }
                    }
                }
            }

            var textarea = $("#MessageTextArea").data("kendoTextArea");
            if (textarea != null && textarea != undefined) {
                textarea.value(precomMsgScenarioText);
            }
        },

        loadExtraInfo: function () {

            var precomMsgScenarioMsgID = 0;

            var ddlPreComMsgScenarioMsg = $("#PreComMsgScenarioMsgID").data("kendoDropDownList");

            if (ddlPreComMsgScenarioMsg != null && ddlPreComMsgScenarioMsg != undefined) {
                precomMsgScenarioMsgID = ddlPreComMsgScenarioMsg.value();
            }

            $("#DivExtraInfo").load(appsettings.getUrl("PreComMsgLog/GetExtraInfo?precomMsgScenarioMsgID=" + precomMsgScenarioMsgID));
        },

        onExtraInfoTextChanged: function () {

            // clear TextBox
            var textarea = $("#MessageTextArea").data("kendoTextArea");
            textarea.value("");

            // put messages in TextBox
            precommsglog.updateTextAreaWithScenarioInfo();

            var msgtxt = textarea.value();

            var extraInfoTexts = $("input[id^='ExtraInfoText_']");

            for (var i = 0; i < extraInfoTexts.length; i++) {

                var ddl = $("#ExtraInfoText_" + i).data("kendoDropDownList");

                if (ddl != null && ddl != undefined && ddl.select() != 0) {
                    var lbl = $("#ExtraInfoLabel_" + i);
                    msgtxt += ", " + lbl[0].textContent + ": " + ddl.dataItem(ddl.select()).Text;
                }
            }

            textarea.value(msgtxt);
        },

        onSentByChanged: function (e) {

            var show = false;
            var valset = e.sender.element[0].value;

            switch (valset) {

                case SendByEnum.Email:
                    show = false;
                    break;

                case SendByEnum.PreComMsg:
                    show = true;
                    break;
            }

            main.setHideDivBootstrap("DivCBResponse", show);
            main.setHideDivBootstrap("DivCalculateGroup", show);
        },

        onCalculateGroupChanged: function (e) {

            var cb = $("#Response").data("kendoCheckBox");
            cb.element[0].checked = true;

            main.setHideDivBootstrap("DivDDLCalculateGroup", e.checked);
        },

        onDDLCalculateGroupChanged: function (e) {

            if (e.sender.element[0].value != null && e.sender.element[0].value != undefined) {
                addGroupToSelected(e.sender.element[0].value);
            }
        },

        onValidFromChanged: function (e) {

            main.setHideDivBootstrap("DivDTValidFrom", e.checked);
        },

        onSendButtonClicked: function (e) {

            $("#" + e.id).attr("disabled", "disabled");

            var ddlSentBy = $("#DDL_SentBy").data("kendoDropDownList");
            var sentBy = ddlSentBy.dataItem(ddlSentBy.selected).Value;

            var cbPriority = $("#Priority").data("kendoCheckBox");
            var priority = cbPriority.element[0].checked;

            var cbResponse = $("#Response").data("kendoCheckBox");
            var response = cbResponse.element[0].checked;

            var calculateGroupID = null;
            var cbCalculateGroup = $("#CalculateGroup").data("kendoCheckBox");
            if (cbCalculateGroup.element[0].checked) {
                var ddlCalGrp = $("#DDL_CalculateGroup").data("kendoDropDownList");
                if (ddlCalGrp != null && ddlCalGrp != undefined) {
                    calculateGroupID = ddlCalGrp.dataItem(ddlCalGrp.selected).Value;
                }
            }

            var validFrom = null;
            var cbValidFrom = $("#CB_ValidFrom").data("kendoCheckBox");
            if (cbValidFrom.element[0].checked) {
                validFrom = $("#DTValidFrom").data("kendoDateTimePicker").value().toUTCString();
            }

            var list = JSON.stringify($("#PreComMsg_CplSelected").data("kendoListBox").dataItems());

            var message = $("#MessageTextArea").data("kendoTextArea").value();

            $.ajax({
                type: "POST",
                data:
                {
                    sentBy: sentBy,
                    priority: priority,
                    response: response,
                    calculateGroupID: calculateGroupID,
                    validFrom: validFrom,
                    messageText: message,
                    assigned: list
                },
                url: appsettings.getUrl("PreComMsgLog/Submit"),
                success: function (responseData) {
                                        
                    form.showServerResponse("preComLogMsg", responseData, function () {

                        $("#" + e.id).removeAttr("disabled");

                        if (responseData != null && responseData != undefined) {
                            if (responseData.Succesfully) {
                                // Get current state
                                var state = History.getState();

                                // Script go back one step
                                breadcrumb.NavigateTo((state.data.step))
                            }
                        }
                    });
                    
                }
            });
        },






        //--- LR ------------------------------------------------------------//

        LR_Initialize: function (notsaved) {
            _msg_notsaved = notsaved;
        },

        /**
        * Return label changed not saved
        */
        LR_LDataChangedNotSavedYet: function () {
            return _msg_notsaved;
        },

        EnableSaveButton: function () {
            var saveButton = $("#SaveButton");

            if (saveButton.length > 0) {
                saveButton.data("kendoButton").enable(true);
            }
        },

        LR_rightClicked: function () {
            this.EnableSaveButton();
            listbox.moveItems("PreComMsg_CplNotSelected", "PreComMsg_CplSelected", "#LR_Validation", precommsglog.LR_LDataChangedNotSavedYet);
        },

        LR_leftClicked: function () {
            this.EnableSaveButton();
            listbox.moveItems("PreComMsg_CplSelected", "PreComMsg_CplNotSelected", "#LR_Validation", precommsglog.LR_LDataChangedNotSavedYet);
        },

    }
}();